import React from 'react';
import { FinnTheHuman } from "phosphor-react";

export const HomeIcon = () => {
  return (
    <FinnTheHuman className='text-primary dark:text-white opacity-70 group-hover:opacity-100 hidden lg:block text-3xl xl:text-5xl sm:mr-2' />
  )
}